export const POCKET_SETTINGS = {
  hubspot: '',
  mixpanel: process.env.REACT_APP_MIXPANEL_TOKEN,
  enableMixpanel: true,
  enableHubspot: false,
  enableSegment: false,
};

export const setupPocket = (): void => {
  window.POCKET_ENV = POCKET_SETTINGS;

  const pocketScript = document.createElement('script');
  pocketScript.setAttribute(
    'src',
    'https://dnnsjdj5swfc3.cloudfront.net/front-end/libs/pocket.latest.js',
  );
  document.body.appendChild(pocketScript);
};

export const checkPocketLoaded = (): void => {
  const errorMessage = `POCKET did not load yet`;

  if (!global.window || !global.window.POCKET) {
    throw new Error(errorMessage);
  }
};
